/* eslint-disable */

import React, { useState } from "react";

const DUMMY_IMG = "assets/img/product/noimage.png"

const ImageWithBasePath = (props) => {

  const { isApiImage } = props;

  const altText = String(props.alt);

  const [fullSrc, setFullSrc] = useState(typeof props.src === "object"
    ? URL.createObjectURL(props?.src)
    : `${isApiImage == true ? process.env.REACT_APP_IMAGE_URL : ""}${props.src}`)


  const handleError = () => {
    setFullSrc(DUMMY_IMG)
  }

  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={altText}
      width={props.width}
      id={props.id}
      onError={handleError}
    />
  );
};

export default ImageWithBasePath;
